/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { WORDPRESS } from 'middleware/wordpress';

export const GET_POSTS_REQUEST = 'GET_POSTS_REQUEST';
export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
export const GET_POSTS_FAILURE = 'GET_POSTS_FAILURE';

/**
 * Get posts from wordpress.com-blog
 *
 * @param {string} query - The posts query string, example ?tag=english.
 * https://developer.wordpress.com/docs/api/1.1/get/sites/%24site/posts/
 *
 * @return {Object}
 */
export const getPosts = (query = '') => ({
  [WORDPRESS]: {
    endpoint: `/posts${query}`,
    method: 'GET',
    types: [GET_POSTS_REQUEST, GET_POSTS_SUCCESS, GET_POSTS_FAILURE],
  },
});

export const GET_POST_REQUEST = 'GET_POST_REQUEST';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAILURE = 'GET_POST_FAILURE';

/**
 * Get single post from wordpress.com-blog
 *
 * @param {string} slug - The post slug.
 *
 * @return {Object}
 */
export const getPost = slug => ({
  [WORDPRESS]: {
    endpoint: `/posts/slug:${slug}`,
    method: 'GET',
    types: [GET_POST_REQUEST, GET_POST_SUCCESS, GET_POST_FAILURE],
  },
});

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

/**
 * Get categories wordpress.com-blog
 *
 * @return {Object}
 */
export const getCategories = () => ({
  [WORDPRESS]: {
    endpoint: '/categories',
    method: 'GET',
    types: [
      GET_CATEGORIES_REQUEST,
      GET_CATEGORIES_SUCCESS,
      GET_CATEGORIES_FAILURE,
    ],
  },
});
